export default __webpack_public_path__ + "static/date-label-dont-3-dark-5974a22934884ed1fa05c12864f423160d0be550c63656f15783450c30b9d62e.png";